export interface SectionTypeConfig {
  id: string
  i18nKey: string
  color: string
}

export const SECTION_TYPES: SectionTypeConfig[] = [
  { id: 'intro',      i18nKey: 'songbook.section.intro',      color: 'bg-purple-600' },
  { id: 'strophe',    i18nKey: 'songbook.section.strophe',    color: 'bg-blue-600' },
  { id: 'refrain',    i18nKey: 'songbook.section.refrain',    color: 'bg-green-600' },
  { id: 'bridge',     i18nKey: 'songbook.section.bridge',     color: 'bg-yellow-600' },
  { id: 'mittelteil', i18nKey: 'songbook.section.mittelteil', color: 'bg-orange-600' },
  { id: 'solo',       i18nKey: 'songbook.section.solo',       color: 'bg-red-600' },
  { id: 'coda',       i18nKey: 'songbook.section.coda',       color: 'bg-pink-600' },
  { id: 'custom',     i18nKey: 'songbook.section.custom',     color: 'bg-gray-600' },
]

export interface InstrumentTypeConfig {
  id: string
  i18nKey: string
  icon: string // emoji or short text
}

export const INSTRUMENT_TYPES: InstrumentTypeConfig[] = [
  { id: 'guitar',   i18nKey: 'songbook.instrument.guitar',   icon: '🎸' },
  { id: 'bass',     i18nKey: 'songbook.instrument.bass',     icon: '🎸' },
  { id: 'keyboard', i18nKey: 'songbook.instrument.keyboard', icon: '🎹' },
  { id: 'custom',   i18nKey: 'songbook.instrument.custom',   icon: '🎵' },
]

export const TAB_STRINGS = 6
export const TAB_FRETS = 5

// Image element settings
export const IMAGE_MAX_HEIGHT = 500
export const IMAGE_MAX_WIDTH = 2000

// MIDI settings
export const MIDI_DEFAULT_TEMPO = 120
export const MIDI_MIN_TEMPO = 40
export const MIDI_MAX_TEMPO = 240

// Audio preview settings
export const AUDIO_MASTER_GAIN = 1.0
export const AUDIO_STRING_GAIN = 0.6
export const AUDIO_HARMONIC_GAIN = 0.2
export const AUDIO_DURATION = 0.8
export const AUDIO_STRUM_DELAY = 0.03
